<template>
  <div data-walkthrough-id="documents-dropzone">
    <ProgressContainer
      v-for="(file, id) in files"
      :key="id"
      :name="file.file.name"
      :progress="file.progress"
    />
    <DirectUploadDropzone
      :on-file-added="handleFileAdded"
      :on-file-progress="handleFileProgress"
      :on-file-uploaded="handleFileUploaded"
      :accept="accept"
      :multiple="true"
    >
      <div
        class="
          sf-layer-border
          sf-layer-rounded
          sf-bg-snow-light
          sf-layer-button
          sf-pad-2
          sf-below-3
        "
      >
        <div class="sf-level">
          <span
            class="sf-font-xl sf-c-snow-darker fa fa-cloud-upload sf-pad-1"
          />
          <div
            v-dompurify-html="
              I18n.t('components.document.dropzone_html', {
                href: `<a>${I18n.t('components.document.browse')}</a>`,
              })
            "
            style="max-width: 200px"
          />
        </div>
      </div>
    </DirectUploadDropzone>
  </div>
</template>

<script>
import ProgressContainer from '@app/shared/vue/components/documents/progress-container'
import DirectUploadDropzone from '@app/shared/vue/components/direct-upload/direct-upload-dropzone'

export default {
  name: 'PermanentDocumentsUploader',

  components: {
    ProgressContainer,
    DirectUploadDropzone,
  },

  props: {
    onFileUploaded: {
      type: Function,
      required: true,
    },
  },

  data: function () {
    return {
      accept: this.accept || '',
      files: {},
    }
  },

  methods: {
    handleFileUploaded({ blob, uuid }) {
      const file = this.files[uuid]
      if (file) {
        file.blob = blob

        this.onFileUploaded(file)

        delete this.files[uuid]
      }
    },

    handleFileAdded({ file, uuid }) {
      const newFile = { file, progress: 0 }
      this.files[uuid] = newFile
    },

    handleFileProgress({ uuid, progress }) {
      const file = this.files[uuid]
      if (file) {
        file.progress = progress
      }
    },
  },
}
</script>
